export default __webpack_public_path__ + "static/image2-42fcde882dded731e774d05ac30769fa.png";